import Bowser from 'bowser';

export const isMobile = () => {
  const { platform: { type } } = Bowser.parse(window.navigator.userAgent);
  return type === 'mobile';
};

export const isIE = () => {
    const { browser: { name } } = Bowser.parse(window.navigator.userAgent);
    return name === 'Internet Explorer';

};